<div class="menuList">
    @if (forKunde()) {
        <div
            class="menuItemWrapper currentClientContainer"
            (click)="goToSelectKunde()">
            <div class="menuItem currentClient" title="Ausgewählter Kunde: {{forKunde().nameVn || forKunde().vsnr}}">
                <div class="icon kunde"></div>
                <div class="label">
                    <span class="title">Ausgewählter Kunde:</span>
                    <span class="name">{{ forKunde().nameVn || forKunde().vsnr }}</span>
                </div>
                <div class="arrow"></div>
            </div>
        </div>
    }

    @for (menupoint of menuListObj; track menupoint; let i = $index) {
        <elem-menupoint
            [active]="menupoint.name == selectedItem"
            [menupoint]="menupoint"
            [hidden]="menupoint.hidden"
            [first]="isFirst(menupoint)"></elem-menupoint>
    }
    <div>
        <!-- Do not touch this. Otherwise the footer below will collide with the
        menu, if it becomes too big because of sub menu items. -->
        <div class="spacer">&#160;</div>
    </div>
</div>

<elem-footer>You can't touch this.</elem-footer>
